import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import ModalPortal from '../../modal-portal';
import { RateBrowserModal } from './index';
import * as Actions from '../../../store/rate-browser/rate-browser.actions';
import * as RateViewerActions from '../../../store/rate-viewer/rate-viewer.actions';
import { RateViewerTypes } from '../../../enums/rate-viewer-types';
import * as CSWActions from '../../../store/csw/csw.actions';
import { buildBrowseRatesRequestFromConfigureRatesModel } from '../../../store/rate-browser/rate-broswer-helpers';
import { concat } from 'rxjs';

export const RateBrowserModalPortalWrapper = ({ close }) => {
  const dispatch = useDispatch();

  const closeModalWithActions = () => {
    dispatch(Actions.closeRateBrowserModal());
    dispatch(RateViewerActions.clearRateViewer(RateViewerTypes.rateBrowser));
    dispatch(CSWActions.resetCSW('rate-browser'));
    close();
  };

  const useOnBrowseRatesWithModal = (model) => {
    const request = buildBrowseRatesRequestFromConfigureRatesModel(model);
    return concat(
      dispatch(Actions.updateConfigureRatesModel(model)),
      dispatch(RateViewerActions.loadRates(RateViewerTypes.rateBrowser, request)),
    );
  };

  // I am passing in a noop function for the modalFrameworkMethods prop because I don't need to use it in this component as I am using
  // the closeModalWithActions function above to close the modal with the modalPortal.
  return (
    <ModalPortal onClose={closeModalWithActions}>
      <RateBrowserModal modalFrameworkMethods={{ closeModal: noop }} onBrowseRates={useOnBrowseRatesWithModal} />
    </ModalPortal>
  );
};

RateBrowserModalPortalWrapper.propTypes = {
  close: PropTypes.func.isRequired,
};
